import Vue from 'vue';
import Router from 'vue-router';
import { formatRoutes } from '@/utils/routerUtil';
import store from '@/store';

const routeOpt1 = require('./async/config.async').default;
const routeOpt2 = require('./config').default;

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

// 不需要登录拦截的路由配置
const loginIgnore = {
    names: ['404', '403'], // 根据路由名称匹配
    paths: [
        '/login',
        '/forgot-password',
        '/seekWarehouses',
        '/detail',
        '/enterprise/authentication',
        '/enterprise/successAuth',
        '/application/replenishment',
        '/smartWiring',
        '/otmsSmartWiring',
        '/application/smartWiring/detail',
        '/application/lineSheet',
        '/application/plannedOrderManage',
        '/wxscancode',
        '/trunkNetwork/approval?type=applyLoad'
        // '/create-multiple',
        // '/taskList'
    ], // 根据路由fullPath匹配
    /**
     * 判断路由是否包含在该配置中
     * @param route vue-router 的 route 对象
     * @returns {boolean}
     */
    includes(route) {
        return this.names.includes(route.name) || this.paths.includes(route.path);
    }
};

/**
 * 初始化路由实例
 * @param isAsync 是否异步路由模式
 * @returns {VueRouter}
 */
function initRouter(isAsync) {
    const options = isAsync ? routeOpt1 : routeOpt2;
    formatRoutes(options.routes);
    return new Router(options);
}
const router = initRouter(store.state.setting.asyncRoute);

export { loginIgnore, router };
